const allSowControlDivs = document.querySelectorAll(".form-field--sow");

if (allSowControlDivs.length) {
    allSowControlDivs.forEach((wrap) => {
        const filenameSpan = wrap.querySelector(".filename");
        const input = wrap.querySelector(".sow-input");
        const checkbox = wrap.querySelector("#sow-use-existent");
        const uploadBtn = wrap.querySelector(".btn--sow-sales");

        if (checkbox) {
            checkbox.addEventListener("change", (e) => {
                const isChecked = e.target.checked;

                if (isChecked) {
                    uploadBtn.disabled = true;
                } else {
                    uploadBtn.disabled = false;
                }
            });
        }

        if (uploadBtn) {
            uploadBtn.addEventListener("click", () => {
                if (!uploadBtn.disabled) {
                    input.click();
                }
            });
        }

        if (input) {
            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    filenameSpan.innerHTML = filename;
                }
            });
        }
    });
}
